import { pick, extend } from 'underscore';

export const getPreviewCarouselStyles = ({ styleOverrides = {}, numberOfElements }) => (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => {
  const overrides = pick(styleOverrides, [
    'carouselRoot',
    'bottomCarouselNavigation',
    'carouselNavigation',
  ]);

  return {
    carouselRoot: extend({
      '& .carousel-inner': {
        paddingBottom: 64,
        '& > .item.active': {
          paddingLeft: 24,
          paddingRight: 24,
        },
      },
      '& ol.carousel-indicators': {
        position: 'absolute',
        bottom: 0,
        width: 'auto',

        '& li': {
          background: 'none',
          border: '1px solid #605E5C',
          borderRadius: 10,
          margin: '0 10px 0 0',
          height: 10,
          width: 10,
        },

        '& li.active': {
          background: palette.themePrimary,
          border: `1px solid ${palette.themePrimary}`,
        },
      },

      '& .carousel-controls': {
        display: 'none',
      },

      '& .carousel-control': {
        color: palette.themePrimary,
        position: 'absolute',
        left: 'auto',
        top: 'auto',
        right: 0,
        bottom: 0,
        height: 32,
        width: 20,
        margin: '20px 24px',
        textShadow: 'none',

        '&:focus': {
          outline: `1px solid ${palette.neutralSecondary}`,
        },

        '&.left': {
          marginRight: 76,
        },

        '& .glyphicon-chevron-left, & .glyphicon-chevron-right': {
          fontFamily: iconFontFamily,
          position: 'relative',
          top: 'auto',
          right: 'auto',
          bottom: 'auto',
          left: 'auto',
          margin: 0,
          fontSize: 16,
          lineHeight: 1,
          verticalAlign: 0,
        },
      },
    }, overrides.carouselRoot),
    bottomCarouselNavigation: extend({
      '& .carousel-control.left': {
        position: 'absolute',
        left: 0,
        marginLeft: 15,
        marginRight: 76,
        marginTop: 20,
        bottom: -7,
        background: 'transparent',
      },
      '& .carousel-control.right': {
        position: 'absolute',
        left: 0,
        bottom: -7,
        marginTop: 20,
        marginLeft: (145 / 3) + ((65 * numberOfElements) / 3),
        background: 'transparent',
      },
      '& .carousel-indicators': {
        left: '20px !important',
        margin: '20px 24px !important',
      },
      '& .carousel-inner > .item.active': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    }, overrides.bottomCarouselNavigation),
    carouselNavigation: extend({
      '& .carousel-control.left': {
        position: 'absolute',
        left: 0,
        marginLeft: 15,
        bottom: -7,
      },
      '& .carousel-control.right': {
        position: 'absolute',
        left: 45,
        bottom: -7,
        marginLeft: 155,
      },
      '& .carousel-indicators': {
        left: '20px',
      },
    }, overrides.carouselNavigation),
    hideNavigation: {
      '& .carousel-control': {
        display: 'none !important',
      },
      '& .carousel-indicators': {
        display: 'none !important',
      },
    },
  };
};

export const getPreviewCarouselLayoutStyles = ({ styleOverrides = {} }) => () => ({
  root: extend({
    border: '1px solid #C8C8C8',
    margin: 0,
    width: '100%',
    minWidth: 669,
  }, styleOverrides.root),
});
